export default "__VITE_ASSET__j56JxfOK__"